import axios from '@/axios.js'

export default {
  getCounters: ({ commit },params) => {
    return new Promise((resolve, reject) => {
      axios
        .get('sales-and-purchase/drcc/counters',{params:params})
        .then(res => {
          resolve(res.data)
        })
        .catch(err => reject(err))
    })
  },
  addCounter: ({commit}, payload) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/sales-and-purchase/drcc/counter', payload)
        .then(res => {
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  // updateGST: ({ commit }, { id, data }) => {
  //   return new Promise((resolve, reject) => {
  //     axios
  //       .put('sales-and-purchase/drcc/gst/' + id, data)
  //       .then(res => {
  //         commit('UPDATE_GST', res.data)
  //         resolve()
  //       })
  //       .catch(err => reject(err))
  //   })
  // },
  updateCounter( context,payload) {
    let { _id } = payload;
    return axios.put(`sales-and-purchase/drcc/counter/${_id}`, payload)
    .then((response) => {
      // console.log(response)
      return  response.data.data ;
    }).catch((e) => {
      console.log(e);
      throw e
    })
  },
  deleteCounter: ({ commit }, { id }) => {
    return new Promise((resolve, reject) => {
      axios
        .delete('/sales-and-purchase/drcc/counter/' + id)
        .then(() => {
          commit('DELETE_GST', id)
          resolve()
        })
        .catch(err => reject(err))
    })
  },
  getCounter(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`sales-and-purchase/drcc/counter/${id}`).then((response) => {
        resolve(response.data.data)
      }).catch((e) => {
        
        console.log(e);
        reject(e)
      });
    })
  },
  getCounterLatest(context, id) {
    return new Promise((resolve, reject) => {
      axios.get(`sales-and-purchase/drcc/counter/${id}?latest=true`).then((response) => {
        /**
         * Expected response.data.data
         * {canNext:boolean,counter:Counter,poNumber:string,poStatus:poStatus,poId:string,isNotCash:boolean}
         */
        resolve(response.data.data)
      }).catch((e) => {
        console.log(e);
        reject(e)
      });
    })
  },
  counterNextQueue(context, id) {
    return new Promise((resolve, reject) => {
      axios.post(`sales-and-purchase/drcc/counter/next/${id}`).then((response) => {
        resolve(response.data.data)
      }).catch((e) => {
        
        console.log(e);
        reject(e)
      });
    })
  },
  counterMissQueue(context, id) {
    return new Promise((resolve, reject) => {
      axios.post(`sales-and-purchase/drcc/counter/miss/${id}`).then((response) => {
        resolve(response.data.data)
      }).catch((e) => {
        console.log(e);
        reject(e)
      });
    })
  }
}